import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IMyKnownError } from 'interfaces/requests';
import { epsClear } from 'modules/eps';
import { FORM_MODE } from '../../shared/enums';

const initialState: FORM_MODE = FORM_MODE.list as FORM_MODE;

export const setEpsModeAction = createAsyncThunk<
  FORM_MODE,
  FORM_MODE,
  { rejectValue: IMyKnownError }
>('epsNavigationMode/set', async (payload, { dispatch }) => {
  if (payload === FORM_MODE.create) {
    dispatch(epsClear());
  }

  return payload;
});

const epsNavigationModeSlice = createSlice({
  name: 'epsNavigationMode',
  initialState,
  reducers: {
    resetEpsModeAction(state) {
      state = initialState;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setEpsModeAction.fulfilled, (state, { payload }) => {
      state = payload;
      return state;
    });
  },
});

const { reducer, actions } = epsNavigationModeSlice;
export const { resetEpsModeAction } = actions;
export default reducer;
